<template>
    <van-form>
        <van-cell-group title="个人信息卡" inset>
            <van-field left-icon="user-o" v-model="userInfo.realName" label="真实姓名" readonly />
            <van-field left-icon="phone-o" v-model="userInfo.phone" label="预留手机号" readonly />
            <van-field left-icon="wap-home" v-model="userInfo.hospitalName" label="体检机构" readonl>
                <template #button>
                    <van-button size="small" type="primary" @click="showPopup">我要更换机构</van-button>
                </template>
            </van-field>
        </van-cell-group>
    </van-form>
    <van-divider :style="{ color: '#fa8a19', borderColor: '#fa8a19', padding: '0 16px' }" />
    <van-tabs v-model:active="active">
        <van-tab title="健康管理计划">
            <van-cell-group title="服务计划" inset>
                <div id="manager" style="float:left;margin-left:20px;">
                    <van-steps direction="vertical" :active="showStepNum">
                        <van-step v-for="(userHealthPlanVo, id) in planList.userHealthPlanVo" :key="id"
                            @click="showStepPopup(userHealthPlanVo.summaryId,userHealthPlanVo.id);">
                            <h4 align="left">{{ userHealthPlanVo.realTime }}{{ userHealthPlanVo.planName }}<van-tag
                                    type="warning" v-if="userHealthPlanVo.tag">有总结</van-tag></h4>
                            <p class="text2DIndentation">{{ userHealthPlanVo.remark }}</p>
                            <p class="text2DIndentation">{{ userHealthPlanVo.planTime }}</p>
                            <p class="text2DIndentation">{{ userHealthPlanVo.realTime }}</p>
                        </van-step>

                        <van-step>
                            <p>...</p>
                        </van-step>
                    </van-steps>
                </div>
            </van-cell-group>
        </van-tab>

        <van-tab title="服务订阅信息">
            <van-cell-group v-for="(userOrderVo, id) in userOrderList.userOrderVo" :key="id" title="服务包" inset>
                <van-field left-icon="gift-card-o" v-model="invitationCode" label="服务名称"
                    :model-value="userOrderVo.productName" readonly input-align="left" />
                <van-field v-model="proStype" label="服务方式" :model-value="userOrderVo.productType" readonly
                    input-align="left" />
                <van-field v-model="amount" label="产品编号" :model-value="userOrderVo.productCode" readonly
                    input-align="left" />
                <van-field v-model="proState" label="当前状态" :model-value="userOrderVo.remark" readonly input-align="left"
                    error>
                </van-field>
            </van-cell-group>
            <br />
            <van-button to="productList" color="linear-gradient(to right, #f67f34, #d55809)" block>了解产品服务</van-button>
        </van-tab>
    </van-tabs>

    <!-- 圆角弹窗（居中） -->
    <van-popup v-model:show="show" position="top" :style="{ height: '15%' }">
        <van-notice-bar wrapable :scrollable="false" text="早知心，目前仅开放体检机构定向邀约客户绑定。如果您想换绑机构，需要您联系您的新的体检机构，
  让其提供【早知心分配给该体检机构的二维码】，然后您用微信直接【扫码换绑】。
  感谢您的支持！" left-icon="info-o" />
    </van-popup>
    <van-popup v-model:show="showStep" round closeable position="bottom" :style="{ height: '70%' }">
        <div class="oddRoundElement" v-if="summaryFlag">
            <p class="textSummaryIndentation">{{ textTag }}</p>
            <p class="textSummaryTitle">{{ oneName }}</p>
            <p class="textSummaryBody">{{ summaryVo.doctorSummary.one }}</p>
            <p class="textSummaryTitle">{{ twoName }}</p>
            <p class="textSummaryBody">{{ summaryVo.doctorSummary.two }}</p>
            <p class="textSummaryTitle">{{ threeName }}</p>
            <p class="textSummaryBody">{{ summaryVo.doctorSummary.three }}</p>
        </div>
        <br />
        <van-divider :style="{ color: '#fa8a19', borderColor: '#fa8a19', padding: '0 16px' }">您可以对本次事项评价</van-divider>
        <van-form>
            <van-field name="rate" label="服务">
                <template #input>
                    <van-rate v-model="userSummaryVo.userSummary.star" :size="25" />
                </template>
            </van-field>
            <br />
            <div style="margin: 16px;">
                <van-button round block type="warning" @click="userSummary">
                    评价提交
                </van-button>
            </div>
        </van-form>
    </van-popup>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
        <div class="wrapper" @click.stop>
            <div class="block">
                <van-cell-group inset>
                    <van-notice-bar wrapable :scrollable="false" text="异常提醒" left-icon="info-o" />
                    <p class="textIndentation">
                        <van-notice-bar wrapable :scrollable="false" color="#1989fa" background="#ffffff">{{ bingingNotice
                        }}</van-notice-bar>
                    </p>
                    <van-button v-if="goToUserInfo" type="warning" block plain hairline to="bindingHosp">
                        开始绑定
                    </van-button>
                    <van-button v-if="goToAbout" type="warning" block plain hairline to="about">
                        返回项目介绍
                    </van-button>
                </van-cell-group>
            </div>
        </div>
    </van-overlay>
</template>
 
<script>
import { ref, toRefs, reactive, onMounted } from 'vue';
import { getUserInfo, getUserHealthPlanInfo, getUserOrderList,addUserSummary } from '../../api/userinfo'
import { getCheckBinding } from '../../api/permission'
import request from '../../utils/request';
import { showSuccessToast, showFailToast } from 'vant';
import { useRouter } from 'vue-router';
import { postUserLog } from "../../api/userlog";
export default {

    setup() {
        const router = useRouter();
        const ulog = reactive({
            UserLog: {
                 path: "",
            },
        });
        const show = ref(false);
        const showStep = ref(false);
        const showOverlay = ref(false);
        const showBinging = ref(false);
        const bingingNotice = ref('');
        const goToAbout = ref(false);
        const goToUserInfo = ref(false);
        const oneName = ref('');
        const textTag = ref('');
        const twoName = ref('');
        const threeName = ref('');
        const showStepNum = ref(0);
        const active = ref(0);
        const summaryFlag = ref(false);
        const action = ref(0);
        const expertise = ref(0);
        const state = reactive({
            userInfo: {
                hospitalName: '',
                area: '',
                realName: '',
                phone: '',
                age: '',
                gender: ''
            }
        })
        const planList = reactive({
            userHealthPlanVo: {
                id: '',
                planCode: '',
                planName: '',
                realTime: '',
                planTime: '',
                process: '',
                summaryId: '',
                tag: '',
                isSummery: '',
                isComments: '',
                remark: '',

            }
        })
        const userOrderList = reactive({
            userOrderVo: {
                wxOpenId: '',
                productCode: '',
                productName: '',
                productType: '',
                remark: '',
            }
        })
        const summaryVo = reactive({
            doctorSummary: {
                doctorSummaryId: '',
                summaryType: '',
                one: '',
                two: '',
                three: '',
                nextTime: '',
            }
        })
        
        const userSummaryVo =reactive({
            userSummary:{
                id: '',
                wxOpenID: '',
                planId: '',
                star: '',
                remark: '',
            }
        })
        const showPopup = () => {
            show.value = true; 
        };
        const userSummary = () =>{
            console.log("评价获得数据"+userSummaryVo.userSummary.planId)
            console.log("评价级别"+userSummaryVo.userSummary.star)
            addUserSummary(userSummaryVo.userSummary).then((res) => {
                if (res.data.code == 20000) {
                    console.log('评价成功'); 
                    showSuccessToast('评价成功');
                    //userSummaryVo.userSummary=res.data.data;
                } else {
                    showFailToast.log('评价失败，网络问题');
                }
            })
        }
        const showStepPopup = (value1,value2) => {
            console.log(value1);
            //初始化医生反馈
            if (value1 != null) {
                summaryFlag.value = true;
                request.get('/wxmanager/plan/doctorSummary', {
                    params: {
                        doctorSummaryId: value1
                    }
                }).then((res) => {
                    summaryVo.doctorSummary = res.data.data;
                    if (summaryVo.doctorSummary.summaryType == 1) {
                        textTag.value = '您好！根据您的风险情况和各类因素，多科室基于临床指南，建议您:';
                        oneName.value = '心内科';
                        twoName.value = '中医科';
                        threeName.value = '补充';
                    } else if (summaryVo.doctorSummary.summaryType == 2) {
                        textTag.value = '专家对您的健康整体评估如下:'
                        oneName.value = '运动';
                        twoName.value = '饮食';
                        threeName.value = '中医';
                    } else if (summaryVo.doctorSummary.summaryType == 3) {
                        textTag.value = '您好，心健康计划-中医阶段总结:'
                        oneName.value = '';
                        twoName.value = '';
                        threeName.value = '阶段总结';
                    } else {
                        summaryFlag.value = false;
                        textTag.value = '';
                        oneName.value = '';
                        twoName.value = '';
                        threeName.value = '';
                        console.log("error 类型无法识别");
                    }

                })
            } else {
                summaryFlag.value = false;
                textTag.value = '';
                oneName.value = '';
                twoName.value = '';
                threeName.value = '';
            }
            //初始化评论
            if(value2!=null){
                console.log(value2);
                request.get('/wxmanager/plan/userSummaryInfo', {
                    params: {
                        healthId: value2
                    }
                }).then((res) => {
                    console.log(res.data.data)
                    userSummaryVo.userSummary = res.data.data;
                })
            }
            showStep.value = true;
        };
       
        onMounted(() => {
            ulog.UserLog.path = router.currentRoute.value.fullPath;
            console.log("当前页面路径==" + ulog.UserLog.path);
            postUserLog(ulog.UserLog).then(() => {});
            console.log('页面打开')
            getCheckBinding().then((res1) => {
                console.log(res1.data.code);
                const binding = res1.data.code;
                if (binding == 60002) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定进度未完成】：还没有最终确认!我们会在1～3个工作日内完成";
                    goToAbout.value = true;
                } else if (binding == 60000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【绑定异常】：早知心，目前仅提供邀约客户绑定。您可以向您的体检机构获取【邀请码】";
                    goToUserInfo.value = true;
                } else if (binding == 40000) {
                    showOverlay.value = true;
                    bingingNotice.value = "【登陆异常】：请您在微信端打开";
                    goToAbout.value = true;
                } else {
                    getUserOrderList().then((res) => {
                        console.log(res.data.data);
                        userOrderList.userOrderVo = res.data.data;
                    })
                    getUserInfo().then((res3) => {
                        state.userInfo = res3.data.data;
                        console.log(res3.data.data);
                    })
                    getUserHealthPlanInfo().then((res2) => {
                        planList.userHealthPlanVo = res2.data.data;
                        console.log(res2.data.data);
                        showStepNum.value = res2.data.count;
                    })
                }
            })
        })
        return {
            show,
            oneName,
            twoName,
            threeName,
            summaryFlag,
            textTag,
            active,
            showOverlay,
            showBinging,
            userOrderList,
            action,
            expertise,
            showStep,
            planList,
            showStepNum,
            bingingNotice,
            goToUserInfo,
            goToAbout,
            summaryVo,
            userSummaryVo,
            userSummary,
            ...toRefs(state),
            showPopup,
            showStepPopup,
        };
    },
};
</script>
<style scoped lang="css" src="./assets/basic_index.css" />